<template>
  <aside v-show="!!products" class="sidebar px-lg py-lg bg-white">
    <a @click="toggle" class="toggle reset cursor-pointer hidden absolute md:block">
      <SloIcon name="ArrowDownToLine" class="c-gray-500" />
    </a>
    <div class="sidebar-content md:mt-xl">
      <h3 class="text-lg md:text-xl">Featured products</h3>
      <ul v-if="state === 'success' && products.length > 0" class="featured-list reset mt-md">
        <FeaturedProduct
          v-for="(product, index) in products"
          :key="index"
          :product="product"
        />
      </ul>
      <div v-else-if="state === 'loading'" class="mt-md">
        <span class="spinner block" />
      </div>
      <div v-else-if="state === 'success' && !products.length" class="mt-md">
        <p class="text-lg md:text-xl font-italic">
          {{ 'This item has no featured products' | t }}
        </p>
      </div>
      <div v-else-if="state === 'error'" class="mt-md">
        <p class="text-lg md:text-xl font-italic">
          {{ 'Something went wrong while fetching featured products.' | t }}
        </p>
      </div>
    </div>
  </aside>
</template>

<script>
import t from '../../main/i18n';
import FeaturedProduct from './FeaturedProduct.vue';
import SloIcon from '../../../lib/components/SloIcon.vue';

export default {
  components: {
    FeaturedProduct,
    SloIcon
  },
  props: {
    state: {type: String},
    products: {type: Array, required: true}
  },
  data() {
    return {
      isOpen: true
    };
  },
  filters: {
    t
  },

  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
      this.$emit('toggled');
    }
  }
};
</script>

<style lang="scss" scoped>
.font-italic {
  font-style: italic;
}

.sidebar {
  position: relative;
  width: 100%;

  .toggle {
    top: 53px;
    transform: rotate(90deg);
  }

  .sidebar-content {
    display: none;
  }

  @media screen and (min-width: 992px) {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: 70px;
  }

  &.open {
    .sidebar-content {
      display: block;
    }

    @media screen and (min-width: 992px) {
      width: 33.33%;
      overflow-x: hidden;
      overflow-y: auto;
      -ms-scroll-chaining: none;
      overscroll-behavior: contain;

      .toggle {
        transform: rotate(270deg);
      }
    }
  }
}
</style>
